// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__VYD9D","left":"InfoRow_left__nYXpE"};